import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate, useParams } from 'react-router-dom';
import Field from '../../../_common/field';
import AddressLocationFieldJS from '../../../components/AddressLocationField/AddressLocationFieldJS';
import AddressLocationField from '../../../components/AddressLocationField/AddressLocationField';
import { connect } from 'react-redux';
import { GeoService } from '../../../_services/geo.service';
import { toast } from 'react-toastify';

const LocationPicker = ({ infosetting, match, dispatch, history, user }) => {
    const [step, setStep] = useState("select-location");
    const [locationPermissionState, setLocationPermissionState] = useState(null);
    const [address, setAddress] = useState("");
    const [location, setlocation] = useState(null);
    const [mapRef, setMapRef] = useState(null);
    const { destination_coords, destination_address } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        handlePermission();
    }, []);

    const handlePermission = () => {
        if (navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({ name: 'geolocation' })
                .then(function (result) {
                    if (result.state === "granted") {
                        allowLocationService();
                    }
                    setLocationPermissionState(result.state);

                    result.onchange = function () {
                        setLocationPermissionState(result.state);
                    }
                })
        } else if (navigator.geolocation) {
            allowLocationService();
        }
    }

    const allowLocationService = () => {
        var options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 1000
        };
        navigator.geolocation.getCurrentPosition(({ coords }) => {
            setLocationPermissionState("granted");
            setlocation({ type: "Point", coordinates: [coords.latitude, coords.longitude] });
        }, (err) => {
            setLocationPermissionState("prompt");
        }, options);

    }

    const handleSelectLocationButtonClick = (clear = false) => {
        if (calcualateDistance() > 0) {
            navigate(`/request/select-category/${destination_coords}/${destination_address}/${location.coordinates}/${address}`);
        } else {
            toast.error("Pickup and destination locations must be different!");
        }


    }


    const calcualateDistance = () => {
        const pickupCoords = GeoService.extractCoordsfromURL(location.coordinates + '');
        const destinationCoords = GeoService.extractCoordsfromURL(destination_coords);
        const distanceVal = GeoService.manualDistance(pickupCoords.lat, pickupCoords.lng,
            destinationCoords.lat, destinationCoords.lng);
        return distanceVal;
    }


    return (
        <div className='section'>
            <div className='banner-bg center'>
                <span className='title-white'>Select Pickup Location</span>
            </div>
            <div className='padder'>
                {locationPermissionState && step === "select-location" &&
                    (
                        (locationPermissionState === "prompt" || locationPermissionState === "denied") ? <div
                            className="sl-prompt-container">
                            <div className="sl-heading-container center-content">
                                <span className="sl-heading">Location Services</span>
                                <hr />
                            </div>
                            <div className="sl-body-content center-content">
                                <i aria-hidden="true" class="fa fa-street-view sl-location-icon"></i>

                                <div className="sl-prompt-content">
                                    <span className="primary-text font-weight-bold">{infosetting.title}</span>
                                    <span className="ml-1">uses location services in order to determine proximity of listed businesses and only while you are using the application.</span>
                                </div>
                            </div>
                            <div className="sl-footer-content center-content">
                                <button class="primary-solid-btn" onClick={allowLocationService}>Enable location services</button>
                            </div>
                        </div>
                            :
                            location && <div className="">
                                <div className="column">
                                    <span className="sl-heading primary-text">Select Pickup Location</span>
                                    <span className="sl-sub-heading mt-10">Please move the map to the exact location of pickup</span>
                                    <hr />
                                </div>
                                <div className="sl-body-content">
                                    <div className="sl-address">
                                        <Field>
                                            <AddressLocationField
                                                name="addressVal2"
                                                placeholder="or move the map"
                                                value={address}
                                                location={location}
                                                markerImage='/assets/icons8-marker-red.png'
                                                mapHeight={400}
                                                setMapRefCallback={setMapRef}
                                                marker_coords={destination_coords}
                                                onChange={({ addressVal, addressValLocation }) => {
                                                    setAddress(addressVal);

                                                    if (addressValLocation) {
                                                        setlocation(addressValLocation)
                                                    }
                                                }}

                                            />
                                        </Field>
                                    </div>

                                </div>
                                <div className="submission-container center">
                                    <button class="btn btn-white btn-block" onClick={() => navigate(-1)} disabled={!location}>Back</button>
                                    <button class="btn btn-primary btn-block ml-10" onClick={handleSelectLocationButtonClick} disabled={!location}>Next</button>
                                </div>
                            </div>
                    )
                }
            </div>
        </div>
    );
};


function mapStateToProps(state) {
    return { ...state.authentication, ...state };
}

export default connect(mapStateToProps)(LocationPicker);